import { render, staticRenderFns } from "./ReclameAquiNumberOfComplaints.container.vue?vue&type=template&id=6107a2a2&"
import script from "./ReclameAquiNumberOfComplaints.container.vue?vue&type=script&lang=ts&"
export * from "./ReclameAquiNumberOfComplaints.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports